"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePages = generatePages;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var PLACEHOLDER = '...';

function generatePages(_ref) {
  var totalPages = _ref.totalPages,
      currentPage = _ref.currentPage,
      maxPagesCount = _ref.maxPagesCount;
  var safeTotalPages = Math.max(totalPages, 1);
  var totalPageArr = Array.from(Array(safeTotalPages), function (value, index) {
    return ++index;
  });
  var sliceIndex = Math.floor(maxPagesCount / 2);
  var visiblePages = centeredWindowSlice(totalPageArr, currentPage - 1, sliceIndex);
  return fixedEdgesArray(visiblePages, safeTotalPages);
}

function fixedEdgesArray(array, fixedEnd) {
  var result = _toConsumableArray(array);

  if (array[0] !== 1) {
    result[0] = 1;
    result[1] = PLACEHOLDER;
  }

  var lastPosition = array.length - 1;

  if (array[lastPosition] !== fixedEnd) {
    result[lastPosition] = fixedEnd;
    result[array.length - 2] = PLACEHOLDER;
  }

  return result;
}

function centeredWindowSlice(array, center, sliceSize) {
  return windowSlice(array, center - sliceSize, center + sliceSize);
}

function windowSlice(array, unsafeStart, unsafeEnd) {
  var maxEnd = array.length - 1;
  var prefix = unsafeEnd > maxEnd ? Math.abs(maxEnd - unsafeEnd) : 0;
  var suffix = unsafeStart < 0 ? Math.abs(unsafeStart) : 0;
  var safeStart = Math.max(0, unsafeStart - prefix);
  var safeEnd = Math.min(unsafeEnd + suffix, maxEnd);
  return array.slice(safeStart, safeEnd + 1);
}